import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TX from '@Components/Common/Text';

const BottomButton = ({ text, backgroundColor, Icon, fill, onClick }) => {
  return (
    <ButtonContainer backgroundColor={backgroundColor} onClick={onClick}>
      <ButtonIconWrapper>
        <Icon width={16} height={16} fill={fill} />
      </ButtonIconWrapper>

      <TX.FootnoteM style={{ userSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}>{text}</TX.FootnoteM>
    </ButtonContainer>
  );
};

BottomButton.propTypes = {
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  Icon: PropTypes.elementType.isRequired,
  fill: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

BottomButton.defaultProps = {
  backgroundColor: 'transparent',
  fill: undefined,
};

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonContainer = styled(FlexAlignCenterDiv)`
  width: 100%;
  cursor: pointer;
  padding: 13px 17px;

  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const ButtonIconWrapper = styled(FlexAlignCenterDiv)`
  justify-content: center;

  width: 32px;
  height: 32px;
`;

export default BottomButton;
